import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Button } from 'Components/frameworks/button/Button';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';

export const FlexibilityBlock = ({
  shouldDisplayFlexibility,
  flexibility,
  onFlexibilityChange,
}) => {
  return (
    <div
      className={`animation-duration-500 flex flex-wrap justify-center ${
        shouldDisplayFlexibility ? 'animate-fadeIn' : 'animate-fadeOut'
      }`}
    >
      {[1, 3, 7].map((flexibilityOption) => (
        <Button
          className={classnames('mx-5 mb-5 min-w-[5.875rem] md:mb-0', {
            'border-2': flexibility === flexibilityOption,
          })}
          color={COLORS.BLACK}
          colorBg={COLORS.TRANSPARENT}
          colorBorder={flexibility === flexibilityOption ? COLORS.GREEN : COLORS.BLACK}
          data-testid={`flex-${flexibilityOption}`}
          iconRight={
            flexibility === flexibilityOption
              ? {
                  className: 'text-green',
                  name: ICONS.CHECK,
                }
              : undefined
          }
          key={flexibilityOption}
          onClick={() => onFlexibilityChange(flexibilityOption)}
        >
          {`±${t(`faceting.flexibility.duration_${flexibilityOption}`)}`}
        </Button>
      ))}
    </div>
  );
};
